/* E.N.D. Video carousel — one script for every carousel on the page.
   Play/pause, mute + volume, scrubber, time, optional speed button, arrows, lazy loading,
   and only one video plays at a time across the whole page. */
(function () {
  var I = {
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M8 5v14l11-7z"/></svg>',
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>',
    sound: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M3 9v6h4l5 4V5L7 9H3z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18 6a8.5 8.5 0 0 1 0 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    muted: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M3 9v6h4l5 4V5L7 9H3z"/><path d="M16 9l5 6M21 9l-5 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
  };
  var RATES = [1, 1.25, 1.5, 2];
  function fmt(t) { t = Math.max(0, Math.floor(t || 0)); return Math.floor(t / 60) + ':' + ('0' + t % 60).slice(-2); }
  function allVideos() { return [].slice.call(document.querySelectorAll('[data-evc] video')); }

  function setup(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var wrap = root.querySelector('.evc-wrap'), tr = root.querySelector('.evc-track');
    if (!wrap || !tr) return;
    var pv = root.querySelector('.evc-prev'), nx = root.querySelector('.evc-next');
    var cards = [].slice.call(root.querySelectorAll('.evc-card'));
    var MUTED = wrap.dataset.muted === 'true', LOOP = wrap.dataset.loop === 'true';

    function arrows() {
      var max = tr.scrollWidth - tr.clientWidth;
      if (pv) pv.disabled = tr.scrollLeft <= 2;
      if (nx) nx.disabled = tr.scrollLeft >= max - 2;
      wrap.classList.toggle('is-static', max <= 2);
    }
    function step(d) { var c = cards[0]; if (c) tr.scrollBy({ left: d * (c.offsetWidth + (parseFloat(getComputedStyle(tr).columnGap) || 0)), behavior: 'smooth' }); }
    if (pv) pv.onclick = function () { step(-1); };
    if (nx) nx.onclick = function () { step(1); };
    tr.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', arrows); window.addEventListener('load', arrows); setTimeout(arrows, 50);

    function near(c) { var v = c && c.querySelector('video'); if (v && v.preload === 'none') v.preload = 'metadata'; }
    function warm(c) { var v = c && c.querySelector('video'); if (v && v.preload !== 'auto') { v.preload = 'auto'; try { if (v.readyState < 2) v.load(); } catch (e) {} } }

    cards.forEach(function (c, idx) {
      var v = c.querySelector('video'); if (!v) return;
      var pp = c.querySelector('.evc-pp'), mu = c.querySelector('.evc-mute'), vo = c.querySelector('.evc-vol'),
          sk = c.querySelector('.evc-seek'), tm = c.querySelector('.evc-time'), sp = c.querySelector('.evc-spd'), drag = false, ri = 0;
      v.loop = LOOP; v.muted = MUTED; v.volume = 0.8;

      function prog() { var d = v.duration || 0; if (sk && !drag && d) sk.value = Math.round(v.currentTime / d * 1000); if (tm) tm.textContent = fmt(v.currentTime) + (d ? ' / ' + fmt(d) : ''); }
      function tick() { prog(); if (!v.paused) requestAnimationFrame(tick); }
      v.addEventListener('timeupdate', prog); v.addEventListener('loadedmetadata', prog);
      v.addEventListener('play', function () { requestAnimationFrame(tick); warm(cards[idx + 1]); });
      ['waiting', 'seeking'].forEach(function (e) { v.addEventListener(e, function () { if (!v.paused || e === 'seeking') c.classList.add('is-loading'); }); });
      ['playing', 'canplay', 'seeked', 'pause', 'error'].forEach(function (e) { v.addEventListener(e, function () { c.classList.remove('is-loading'); }); });

      if (sk) {
        sk.addEventListener('input', function () { drag = true; var d = v.duration || 0; if (d) v.currentTime = sk.value / 1000 * d; prog(); });
        ['change', 'pointerup', 'touchend'].forEach(function (e) { sk.addEventListener(e, function () { drag = false; }); });
      }
      function ui() {
        c.classList.toggle('is-playing', !v.paused);
        if (pp) { pp.innerHTML = v.paused ? I.play : I.pause; pp.setAttribute('aria-label', v.paused ? 'Play' : 'Pause'); }
        if (mu) { mu.innerHTML = v.muted ? I.muted : I.sound; mu.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute'); }
        if (vo) vo.value = v.muted ? 0 : Math.round(v.volume * 100);
      }
      function toggle() {
        if (v.paused) {
          allVideos().forEach(function (o) { if (o !== v) o.pause(); });   /* one video at a time, page-wide */
          warm(c); if (v.readyState < 3) c.classList.add('is-loading');
          v.play().catch(function () { v.muted = true; v.play().catch(function () { c.classList.remove('is-loading'); }); });
        } else { v.pause(); }
      }
      var big = c.querySelector('.evc-play'); if (big) big.onclick = toggle;
      if (pp) pp.onclick = toggle;
      if (mu) mu.onclick = function () { v.muted = !v.muted; if (!v.muted && v.volume === 0) v.volume = 0.5; };
      if (vo) vo.oninput = function () { v.volume = this.value / 100; v.muted = +this.value === 0; };
      if (sp) sp.onclick = function () { ri = (ri + 1) % RATES.length; v.playbackRate = v.defaultPlaybackRate = RATES[ri]; sp.textContent = RATES[ri] + 'x'; };
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (e) { c.addEventListener(e, function () { warm(c); }, { passive: true }); });
      ['play', 'pause', 'volumechange'].forEach(function (e) { v.addEventListener(e, ui); }); ui();
    });

    if ('IntersectionObserver' in window) {
      var out = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.intersectionRatio < 0.35) { var v = e.target.querySelector('video'); if (v) v.pause(); } }); }, { threshold: [0, 0.35] });
      var soon = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { near(e.target); soon.unobserve(e.target); } }); }, { rootMargin: '300px' });
      cards.forEach(function (c) { out.observe(c); soon.observe(c); });
    } else { cards.forEach(near); }

    /* "open in new tab" links: open reliably even inside the theme editor preview */
    var b = root.querySelector('.evc-btn[target="_blank"]');
    if (b) b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var w = window.open(b.href, '_blank', 'noopener');
      if (!w) { try { window.top.location.href = b.href; } catch (x) { location.href = b.href; } }
    }, true);
  }

  function init() { document.querySelectorAll('[data-evc]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
